import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useConvertToPendingPal } from "../../store/useConvertToPendingPal";
import { PatientService } from "../../../../../services/patient.service";

import CommentInput from "../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";
import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    data(vm) {
        return {
            commentInputClass: { input: "w-35" } as { input: string; textarea?: string },
            _patientService: null as PatientService,
            popoverContent:
                "The notes entered here will appear on the patient's card, providing patient-specific information."
        };
    },

    computed: {
        ...mapState(useConvertToPendingPal, ["patientDetails", "application"])
    }
});
